import React from "react";

const fieldBaseStyle = {
  width: "100%",
  border: "none",
  borderBottom: "1px solid #1d1d1d",
  borderRadius: 0,
  boxShadow: "none",
  background: "transparent",
  padding: "2px 4px",
  minHeight: "28px",
  fontSize: "14px",
};

export const certificateFieldStyle = fieldBaseStyle;

const CertificateStyledForm = ({
  title,
  actions,
  documentNoControl,
  dateControl,
  introNameControl,
  rows,
  footer = "Principal",
}) => {
  return (
    <div
      className="container-fluid"
      style={{ background: "#dfe9f8", minHeight: "100vh", padding: "24px 12px" }}
    >
      <div className="row justify-content-center">
        <div className="col-12 col-xl-11">
          <div className="d-flex flex-wrap gap-2 mb-3">{actions}</div>

          <div
            style={{
              maxWidth: "820px",
              margin: "0 auto",
              background: "#fff",
              border: "1px solid #1d1d1d",
              padding: "24px 34px 30px",
              position: "relative",
              boxShadow: "0 12px 30px rgba(0, 0, 0, 0.12)",
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: "10px",
                border: "1px solid #1d1d1d",
                pointerEvents: "none",
              }}
            />
            <div style={{ position: "absolute", top: "18px", left: "18px", width: "22px", height: "22px", borderTop: "3px solid #1d1d1d", borderLeft: "3px solid #1d1d1d" }} />
            <div style={{ position: "absolute", top: "18px", right: "18px", width: "22px", height: "22px", borderTop: "3px solid #1d1d1d", borderRight: "3px solid #1d1d1d" }} />
            <div style={{ position: "absolute", bottom: "18px", left: "18px", width: "22px", height: "22px", borderBottom: "3px solid #1d1d1d", borderLeft: "3px solid #1d1d1d" }} />
            <div style={{ position: "absolute", bottom: "18px", right: "18px", width: "22px", height: "22px", borderBottom: "3px solid #1d1d1d", borderRight: "3px solid #1d1d1d" }} />

            <div style={{ position: "relative", zIndex: 1 }}>
              <div className="d-flex justify-content-between align-items-start mb-3" style={{ fontSize: "14px", fontWeight: 600, gap: "16px" }}>
                <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                  <span style={{ whiteSpace: "nowrap", marginRight: "8px" }}>Ref No -</span>
                  <div style={{ flex: 1 }}>{documentNoControl}</div>
                </div>
                <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1, justifyContent: "flex-end" }}>
                  <span style={{ whiteSpace: "nowrap", marginRight: "8px" }}>Date -</span>
                  <div style={{ width: "160px", maxWidth: "100%" }}>{dateControl}</div>
                </div>
              </div>

              <h3 className="text-center" style={{ fontSize: "28px", fontWeight: 700, letterSpacing: "1px", margin: "24px 0 18px" }}>
                {title}
              </h3>

              <div className="text-center" style={{ marginBottom: "28px", fontSize: "15px" }}>
                <span>This is to certify that </span>
                <span style={{ display: "inline-block", width: "220px", maxWidth: "100%", verticalAlign: "middle" }}>
                  {introNameControl}
                </span>
                <span> was a bonafide student of this institution.</span>
              </div>

              <div>
                {rows.map((row, index) => (
                  <div key={`${row.label}-${index}`} className="row align-items-start" style={{ marginBottom: "10px", fontSize: "14px" }}>
                    <div className="col-12 col-md-5 d-flex">
                      <span style={{ width: "18px" }}>•</span>
                      <span>{row.label}</span>
                    </div>
                    <div className="col-1 d-none d-md-block">:</div>
                    <div className="col-12 col-md-6">{row.control}</div>
                  </div>
                ))}
              </div>

              <div className="text-end" style={{ marginTop: "40px", fontStyle: "italic", fontWeight: 500 }}>
                {footer}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateStyledForm;